<mat-card class="mat-mdc-card mdc-card cardWithShadow card2 position-relative card-hover">
    <mat-card-content class="mat-mdc-card-content p-y-24">
        <div class="row d-flex justify-content-between">
            <div class="col-md-12 divDownload">
                <button mat-mini-fab class="excel" (click)="DownLoadUsersExcelReport()">
                    <i-tabler name="file-type-xls" class="routeIcon"></i-tabler>
                </button>

                <button mat-mini-fab class="pdf" (click)="DownLoadUsersPDFReport()">
                    <i-tabler name="file-type-pdf" class="routeIcon"></i-tabler>
                </button>
            </div>
        </div>
        <div class='content'>
            <div class="count" *ngIf="AllUsers.length!=0">{{'Results'| translate}}: {{AllUsers.length}} {{'of'| translate}} {{totalItems}}</div>

            <table>
                <thead>
                    <tr>
                        <th>{{'Name'|translate}}</th>
                        <th>{{'UserType'|translate}}</th>
                        <th>{{'Phone'|translate}}</th>
                        <th>{{'Email'|translate}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let user of AllUsers">
                        <td>{{user.userName}}</td>
                        <td>{{user.userTypeName}}</td>
                        <td>{{user.phoneNumber}}</td>
                        <td>{{user.email}}</td>
                    </tr>

                    <tr *ngIf="AllUsers.length==0">
                        <td colspan="2">{{ 'NoDataFound' | translate }}</td>
                    </tr>
                </tbody>
            </table>

            <mat-paginator *ngIf="AllUsers.length!=0" [length]="totalItems" [pageSize]="pageSize"
                [pageSizeOptions]="[10, 20, 30,40, 50]" [showFirstLastButtons]="true" [pageIndex]="currentPage"
                (page)="onPageChange($event)">
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>